require('angular').module('wowApp.common')
    .service('PastShopService', require('./pastshop.service'));



// WEBPACK FOOTER //
// ./src/common/pastshops/index.js